import { useEffect } from "react";

const upsert = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

const makeMeta = (attr, key) => () => {
  const m = document.createElement("meta");
  m.setAttribute(attr, key);
  return m;
};

const Seo = ({ title, description, path = "/", type = "website", image }) => {
  useEffect(() => {
    const origin = window.location.origin;
    const url = origin + path;
    document.title = title;
    upsert('meta[name="description"]', makeMeta("name", "description")).setAttribute(
      "content",
      description
    );
    upsert('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    }).setAttribute("href", url);
    const og = [
      ["og:title", title],
      ["og:description", description],
      ["og:url", url],
      ["og:type", type],
      ["og:locale", "it_IT"],
      ["og:site_name", "Studio Legale Avv. Manfredi Bruno"],
    ];
    if (image) {
      og.push(["og:image", image.startsWith("http") ? image : origin + image]);
      og.push(["twitter:card", "summary_large_image"]);
    }
    og.forEach(([prop, content]) => {
      const attr = prop.startsWith("twitter:") ? "name" : "property";
      upsert(`meta[${attr}="${prop}"]`, makeMeta(attr, prop)).setAttribute("content", content);
    });
  }, [title, description, path, type, image]);
  return null;
};

export default Seo;
